import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { LivestreamPlayer } from '@feature/livestream/components/LivestreamPlayer';
import { LivestreamChatOverlay } from '@feature/livestream/components/LivestreamChatOverlay';

interface LivestreamViewerModalProps {
  isOpen: boolean;
  livestreamId: string;
  chatChannelId?: string | null;
  onClose: () => void;
}

export function LivestreamViewerModal({
  isOpen,
  livestreamId,
  chatChannelId,
  onClose,
}: LivestreamViewerModalProps): React.ReactElement | null {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div style={styles.modal} onClick={onClose}>
      <button onClick={onClose} style={styles.closeButton}>
        <X size={28} />
      </button>

      <div style={styles.playerContainer} onClick={(e) => e.stopPropagation()}>
        <LivestreamPlayer livestreamId={livestreamId} />
        <LivestreamChatOverlay chatChannelId={chatChannelId} />
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: 'calc(var(--vh, 1vh) * 100)',
    backgroundColor: 'rgba(0, 0, 0, 0.95)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
  },
  closeButton: {
    position: 'absolute',
    top: '30px',
    left: '20px',
    background: 'rgba(0, 0, 0, 0.8)',
    border: 'none',
    borderRadius: '50%',
    width: '48px',
    height: '48px',
    cursor: 'pointer',
    color: 'white',
    zIndex: 10000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  playerContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
};
